const MOBILE_VIEWPORT_QUERY = '(max-width: 768px), (pointer: coarse)'

const isMobileViewport = () => window.matchMedia(MOBILE_VIEWPORT_QUERY).matches

export default defineNuxtPlugin((nuxtApp) => {
  const preventGestureZoom = (event) => {
    if (isMobileViewport())
      event.preventDefault()
  }

  const preventPinchZoom = (event) => {
    if (isMobileViewport() && event.touches?.length > 1)
      event.preventDefault()
  }

  let lastTouchEnd = 0
  const preventDoubleTapZoom = (event) => {
    if (!isMobileViewport())
      return

    const now = Date.now()
    if (now - lastTouchEnd <= 300)
      event.preventDefault()
    lastTouchEnd = now
  }

  const gestureEvents = ['gesturestart', 'gesturechange', 'gestureend']
  gestureEvents.forEach(eventName =>
    document.addEventListener(eventName, preventGestureZoom, { passive: false }),
  )
  document.addEventListener('touchmove', preventPinchZoom, { passive: false })
  document.addEventListener('touchend', preventDoubleTapZoom, { passive: false })

  nuxtApp.hook('app:beforeUnmount', () => {
    gestureEvents.forEach(eventName =>
      document.removeEventListener(eventName, preventGestureZoom),
    )
    document.removeEventListener('touchmove', preventPinchZoom)
    document.removeEventListener('touchend', preventDoubleTapZoom)
  })
})
